import React from "react";
import config from "cfg";
import * as rmd from "material-ui";
import styled from "styled-components";
import { Link } from "react-router";
import auth from "../auth";
import _ from "lodash";
import Promise from "bluebird";
import fetch from "../../../common/fetch";

const PackName = styled.div`
  height: 50px;
  line-height: 50px;
  text-align: left;
  font-weight: 700;
  opacity: 0.5;
  font-weight: 20px;
  padding: 0;
  text-transform: uppercase;
  display: flex;
`;

const PackCellWrapper = styled.div``;

const PackColumnWrapper = styled.div`
  padding: 0 15px 10px;
  background: ${props => (props.index % 2 === 0 ? "#F5F5F5" : "#FFF")};
`;

const UsersPacksDashboardWrapper = styled.div`margin: 20px 0;`;

const Table = styled.div`
  display: flex;
  overflow-y: scroll;
`;

const ControlWrapper = styled.div`
  text-align: center;
  margin: 20px;
  > * {
    margin: 0 10px;
  }
`;

const Loader = styled.div`
  text-align: center;
  display: flex;
  height: calc(100% - 284px);
  > * {
    margin: auto;
  }
`;

const PackColumn = ({ users, pack, onCheck, index }) => {
  let { name, id } = pack;
  return (
    <PackColumnWrapper index={index}>
      <PackName>{name} </PackName>
      {users.map(u => (
        <PackCell onCheck={onCheck} user={u} pack={pack} key={u._id} />
      ))}
    </PackColumnWrapper>
  );
};

const PackCell = ({ pack, user, onCheck }) => {
  let { packs = [], username, client } = user;

  return (
    <PackCellWrapper>
      <rmd.Checkbox
        type="checkbox"
        label={`${username} (${client})`}
        onCheck={(e, isChecked) => {
          onCheck(user._id, pack.id, isChecked);
        }}
        style={{ whiteSpace: "nowrap" }}
        checked={packs.indexOf(pack.id) > -1}
      />
    </PackCellWrapper>
  );
};

class UsersPacksDashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      users: [],
      packs: [],
      dataLoaded: false,
      changed: false,
      showSavedNotification: false,
      showErrorNotification: false,
      showResettedNotification: false,
      newPackName: "",
      newPackDesc: ""
    };
  }

  handleCheck = (userId, packId, isChecked) => {
    let { users } = this.state;
    let clonedUsers = [...users];
    let modifiedUser = clonedUsers.find(u => u._id === userId);

    if (isChecked) {
      modifiedUser.packs.push(packId);
    } else {
      modifiedUser.packs = modifiedUser.packs.filter(p => p !== packId);
    }

    this.setState({
      users: clonedUsers,
      changed: true
    });
  };

  handleSave = () => {
    this.setState(
      {
        saving: true
      },
      () => {
        Promise.props({
          users: fetch.post(
            `${config.dash.api.host}/api/admin/users?access_token=${auth.getAccessToken()}`,
            { method: "PUT" },
            {
              users: this.state.users
            }
          )
        })
          .then(data =>
            this.setState({
              ...data,
              saving: false,
              showSavedNotification: true,
              changed: false
            })
          )
          .catch(err => {
            console.error(err)
            this.setState({
              saving: false,
              showErrorNotification: true,
              errorNotificationMessage: "Could not save. Try again later."
            })
          });
      }
    );
  };

  handleReset = () => {
    this.setState(
      {
        saving: true
      },
      () => {
        this.loadData().then(data =>
          this.setState({
            ...data,
            saving: false,
            changed: false,
            showResettedNotification: true
          })
        );
      }
    );
  };

  componentDidMount = () => {
    this.loadData()
      .then(data => {
        this.setState({ ...data, dataLoaded: true });
      })
      .catch(e => this.setState({ dataLoaded: true, error: true }));
  };

  loadData = () => {
    return Promise.props({
      users: fetch.get(
        `${config.dash.api
          .host}/api/admin/users?access_token=${auth.getAccessToken()}`
      ),
      packs: fetch.get(
        `${config.dash.api
          .host}/api/admin/packs?access_token=${auth.getAccessToken()}`
      )
    })
      .then(data => data)
      .catch(err => console.error(err));
  };

  render() {
    const { packs, users, dataLoaded } = this.state;

    if (!dataLoaded) {
      return (
        <Loader>
          <rmd.CircularProgress size={80} thickness={5} />
        </Loader>
      );
    }

    const noPacksAvailable = !packs.length;

    return (
      <div>
        {!noPacksAvailable && (
          <UsersPacksDashboardWrapper>
            <h3
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center"
              }}
            >
              <span>Users Packs Dashboard for Admin</span>
              <Link to="/admin/packs">
                <rmd.FlatButton
                  disabled={this.state.saving}
                  label={"Manage packs"}
                />
              </Link>
            </h3>
            <Table>
              {_.sortBy(packs, p => p.name).map((p, i) => (
                <PackColumn
                  index={i}
                  pack={p}
                  users={_.sortBy(users, u => u.username)}
                  key={p.name}
                  onCheck={this.handleCheck}
                />
              ))}
            </Table>
            <ControlWrapper>
              <rmd.RaisedButton
                secondary={true}
                disabled={this.state.saving || !this.state.changed}
                label={"Reset to previous"}
                onTouchTap={this.handleReset}
              />
              <rmd.RaisedButton
                primary={true}
                disabled={this.state.saving || !this.state.changed}
                label={this.state.saving ? "Saving..." : this.state.changed ? "Save" : "Saved"}
                onTouchTap={this.handleSave}
              />
            </ControlWrapper>
          </UsersPacksDashboardWrapper>
        )}
        {noPacksAvailable && (
          <div
            style={{
              height: "calc(100% - 284px)",
              width: "100%",
              display: "flex"
            }}
          >
            <div style={{ margin: "auto", textAlign: "center" }}>
              <div
                style={{
                  fontWeight: 700,
                  fontSize: "20px",
                  marginBottom: "15px"
                }}
              >
                There are no packs currently.
              </div>
              <Link to="/admin/packs">
                <rmd.FlatButton
                  disabled={this.state.saving}
                  label={"Manage packs"}
                />
              </Link>
            </div>
          </div>
        )}
        <rmd.Snackbar
          open={this.state.showSavedNotification}
          onRequestClose={() => this.setState({ showSavedNotification: false })}
          autoHideDuration={3000}
          message={"Successfully saved"}
        />
        <rmd.Snackbar
          open={this.state.showResettedNotification}
          onRequestClose={() =>
            this.setState({ showResettedNotification: false })}
          autoHideDuration={3000}
          message={"Successfully resetted to previous state"}
        />
        <rmd.Snackbar
          open={this.state.showErrorNotification}
          onRequestClose={() =>
            this.setState({
              showErrorNotification: false,
              errorNotificationMessage: ""
            })}
          autoHideDuration={3000}
          bodyStyle={{ backgroundColor: "rgba(198,40,40,0.8)" }}
          message={this.state.errorNotificationMessage || "Error occured"}
        />
      </div>
    );
  }
}

export default UsersPacksDashboard;



/** WEBPACK FOOTER **
 ** ../src/dash/front/components/UsersPacksDashboard.js
 **/